(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bulk-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bulk-variant-picker')) {
    customElements.define('bulk-variant-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.rows = Array.from(this.querySelectorAll('[data-row]'));
        this.submitButton = this.querySelector('[type="submit"]');
        this.buttonLabel = this.submitButton.textContent;
        this.message = this.querySelector('[data-message]');
        this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        this.weights = JSON.parse(this.querySelector('[data-rack-weights]')?.textContent || '{}');
        this.rows.forEach(row => { row.priceBreaks = JSON.parse(row.querySelector('[data-price-breaks]').textContent || '[]'); });
        this.querySelectorAll('[name="rack-addon-choice"]').forEach(radio => {
          radio.hidden = false;
          radio.classList.add('m:visually-hidden');
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-adjust]');
          if (!button || this.busy) return;
          const row = button.closest('[data-row]');
          const input = row.querySelector('[data-quantity]');
          const value = Number(input.value) || 0;
          const minimum = Number(row.dataset.min);
          const step = Number(row.dataset.step);
          input.value = button.dataset.adjust === '1' ? (value ? value + step : minimum) : (value <= minimum ? 0 : value - step);
          this.update();
        });
        this.addEventListener('change', () => { if (!this.busy) this.update(); });
        this.form.addEventListener('submit', event => this.addItems(event));
        this.update();
      }

      limit(row) {
        if (row.dataset.available !== 'true') return 0;
        if (row.dataset.max === '') return Infinity;
        const remaining = Math.max(0, Number(row.dataset.max) - Number(row.dataset.cartQuantity));
        const minimum = Number(row.dataset.min);
        const step = Number(row.dataset.step);
        return remaining < minimum ? 0 : minimum + Math.floor((remaining - minimum) / step) * step;
      }

      update() {
        let count = 0;
        let total = 0;
        let compareTotal = 0;
        let heaviest = 0;
        this.rows.forEach(row => {
          const input = row.querySelector('[data-quantity]');
          const minimum = Number(row.dataset.min);
          const step = Number(row.dataset.step);
          const maximum = this.limit(row);
          let quantity = Math.max(0, Math.floor(Number(input.value) || 0));
          if (quantity > 0) quantity = Math.min(maximum, minimum + Math.ceil(Math.max(0, quantity - minimum) / step) * step);
          input.value = quantity;
          input.disabled = this.busy || maximum === 0;
          row.classList.toggle('bulk-pairs__row--unavailable', maximum === 0);
          row.querySelector('[data-stock-label]').hidden = maximum !== 0;
          if (Number.isFinite(maximum)) input.max = maximum;
          row.querySelector('[data-adjust="-1"]').disabled = this.busy || quantity === 0;
          row.querySelector('[data-adjust="1"]').disabled = this.busy || quantity >= maximum;
          row.classList.toggle('is-selected', quantity > 0);
          let price = Number(row.dataset.price);
          const combined = quantity + Number(row.dataset.cartQuantity);
          row.priceBreaks.forEach(tier => { if (combined >= tier.minimum_quantity) price = Math.min(price, tier.price); });
          row.querySelector('[data-unit-price]').textContent = this.money.format(price / 100);
          count += quantity;
          total += quantity * price;
          compareTotal += quantity * Math.max(price, Number(row.dataset.comparePrice) || Number(row.dataset.price));
          if (quantity) heaviest = Math.max(heaviest, parseFloat(this.weights[row.dataset.variantId]) || 0);
        });
        this.querySelectorAll('[data-rack-tile]').forEach(tile => {
          const radio = tile.querySelector('input');
          tile.hidden = heaviest >= parseFloat(tile.dataset.rackHideAt);
          if (tile.hidden && radio.checked) this.querySelector('[name="rack-addon-choice"][value="none"]').checked = true;
          radio.disabled = this.busy || tile.classList.contains('is-disabled');
        });
        this.querySelectorAll('[data-rack-tile]').forEach(tile => {
          const radio = tile.querySelector('input');
          tile.classList.toggle('is-selected', radio.checked);
          if (radio.checked) {
            this.querySelector('[data-rack-selected-name]').textContent = tile.dataset.rackName;
            total += Number(tile.dataset.rackPrice) || 0;
            compareTotal += Math.max(Number(tile.dataset.rackPrice) || 0, Number(tile.dataset.rackComparePrice) || 0);
          }
        });
        this.querySelector('[data-selected-count]').textContent = this.dataset.countLabel.replace('[count]', count);
        this.querySelector('[data-total]').textContent = this.money.format(total / 100);
        const comparePrice = this.querySelector('[data-compare-total]');
        comparePrice.hidden = compareTotal <= total;
        comparePrice.textContent = this.money.format(compareTotal / 100);
        this.submitButton.disabled = this.busy || count === 0;
        this.submitButton.textContent = this.busy ? this.dataset.loadingLabel : this.buttonLabel;
      }

      async addItems(event) {
        event.preventDefault();
        if (this.busy) return;
        this.update();
        const items = this.rows.filter(row => Number(row.querySelector('[data-quantity]').value) > 0).map(row => ({ id: Number(row.dataset.variantId), quantity: Number(row.querySelector('[data-quantity]').value) }));
        if (!items.length) return;
        const rack = this.querySelector('[name="rack-addon-choice"]:checked');
        if (rack && rack.value !== 'none' && !rack.disabled) items.push({ id: Number(rack.value), quantity: 1 });
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.message.textContent = '';
        this.message.classList.remove('is-error');
        this.update();
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          this.rows.forEach(row => { row.dataset.cartQuantity = cart.items.filter(item => String(item.variant_id) === row.dataset.variantId).reduce((sum, item) => sum + item.quantity, 0); });
          if (items.some(item => {
            const row = this.rows.find(candidate => Number(candidate.dataset.variantId) === item.id);
            return row && item.quantity > this.limit(row);
          })) throw new Error(this.dataset.stockError);
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items, sections: [...new Set(sections)], sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          this.rows.forEach(row => {
            const item = items.find(item => String(item.id) === row.dataset.variantId);
            if (item) row.dataset.cartQuantity = Number(row.dataset.cartQuantity) + item.quantity;
            row.querySelector('[data-quantity]').value = 0;
          });
          const none = this.querySelector('[name="rack-addon-choice"][value="none"]');
          if (none) none.checked = true;
          this.message.textContent = this.dataset.success;
          if (!window.MinimogSettings?.use_ajax_atc || Object.values(result.sections || {}).some(section => section === null)) {
            window.location.assign(window.MinimogSettings?.routes?.cart || `${root}cart`);
            return;
          }
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: result });
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));
        } catch (error) {
          if (added) {
            window.location.assign(`${root}cart`);
          } else {
            this.message.textContent = error.message || this.dataset.error;
            this.message.classList.add('is-error');
            document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: this.message.textContent } }));
          }
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eg-v3-purchase-trust"] && !Shopify.designMode) return;
  try {
    /* "Ask Our Team" opens the help chat when it has loaded; otherwise the link goes to the contact page. */
  document.addEventListener('click', event => {
    if (!event.target.closest?.('[data-open-chat]') || !window.$chatwoot?.hasLoaded) return;
    event.preventDefault();
    window.$chatwoot.toggle('open');
  });
  /* Delivery and returns links open their dialog; modified clicks still open the page. */
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-policy-dialog]');
    if (link) {
      const dialog = document.getElementById(link.dataset.policyDialog);
      if (!dialog?.showModal || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      dialog.showModal();
      dialog.querySelector('.egv3-policy-body').scrollTop = 0;
      return;
    }
    const open = event.target.closest?.('.egv3-policy-dialog[open]');
    if (open && (event.target === open || event.target.closest('[data-policy-close]'))) open.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eg-v3-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-egv3-rating]');
    if (!link) return;
    const reviews = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    if (!reviews) return;
    event.preventDefault();
    reviews.scrollIntoView({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
